import React from 'react';
import MythLabsIcon from './MythLabsIcon';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="bubbles">
        {Array.from({ length: 128 }).map((_, i) => {
          const size = 2 + Math.random() * 4;
          const distance = 6 + Math.random() * 4;
          const position = -5 + Math.random() * 110;
          const time = 4 + Math.random() * 3;
          const delay = -1 * (3 + Math.random() * 3);
          return (
            <div
              key={i}
              className="bubble"
              style={{
                '--size': `${size}rem`,
                '--distance': `${distance}rem`,
                '--position': `${position}%`,
                '--time': `${time}s`,
                '--delay': `${delay}s`
              }}
            />
          );
        })}
      </div>
      <div className="content">
        <div>
          <div className="footer-brand">
            <MythLabsIcon className="footer-icon" />
            <span className="footer-brand-text">MythLabs</span>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <p>©{new Date().getFullYear()} MythLabs</p>
      </div>
    </footer>
  );
}

export default Footer;





